var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tabs',{on:{"tab-click":_vm.handleClick},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"请求日志","name":"http"}},[_c('log-http')],1),_c('el-tab-pane',{attrs:{"label":"COS日志","name":"cos"}},[_c('log-cos')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }